import { Box, Grid } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import CustomFieldsTable from './customFieldsTable.component';
import ClientPurposeBuiltFieldsTable from './purposeBuiltFieldsTable.component';

const CustomFieldsTab = ({ formikProps, clientDetails, enumerations, isReadOnly = false }) => {
  return (
    <Box sx={{ padding: '20px' }}>
      {clientDetails.clientCustomFields && (
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <ClientPurposeBuiltFieldsTable clientRecordId={clientDetails.clientDetails.clientRecordId} clientCustomFields={clientDetails.clientCustomFields} enumerations={enumerations.allEnums} divisions={clientDetails.clientDivisions} policies={clientDetails.clientRelocationPolicies} hideEdit={isReadOnly}/>
          <Box sx={{ paddingTop: '16px' }}>
              <CustomFieldsTable clientRecordId={clientDetails.clientDetails.clientRecordId} clientCustomFields={clientDetails.clientCustomFields}  enumerations={enumerations.allEnums} divisions={clientDetails.clientDivisions} policies={clientDetails.clientRelocationPolicies} hideEdit={isReadOnly}/>
          </Box>
        </Grid>
      )}
    </Box>
  );
};

CustomFieldsTab.propTypes = {
  formikProps: PropTypes.object.isRequired,
  clientDetails: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { clientDetails } = state.clients.clientsInfo[state.clients.currentClientId];
  return {
    clientDetails
  };
};

export default compose(connect(mapStateToProps))(CustomFieldsTab);
